const AMR_NB_MAGIC = '#!AMR\n'
const AMR_WB_MAGIC = '#!AMR-WB\n'

/**
 * AMR-NB frame sizes INCLUDING the 1-byte TOC header (20 ms / frame).
 * Modes: 0–7 speech, 8 SID, 9–14 reserved/comfort, 15 no-data.
 */
const AMR_NB_FRAME_SIZES = [13, 14, 16, 18, 20, 21, 27, 32, 6, 7, 6, 6, 1, 1, 1, 1]

/**
 * AMR-WB frame sizes INCLUDING the 1-byte TOC header (20 ms / frame).
 */
const AMR_WB_FRAME_SIZES = [18, 24, 33, 37, 41, 47, 51, 59, 61, 6, 1, 1, 1, 1, 1, 1]

function fileExtension(name = '') {
  const base = String(name).split(/[/\\]/).pop() || ''
  const dot = base.lastIndexOf('.')
  return dot >= 0 ? base.slice(dot + 1).toLowerCase() : ''
}

function bytesStartWith(bytes, text) {
  if (bytes.length < text.length) return false
  for (let i = 0; i < text.length; i++) {
    if (bytes[i] !== text.charCodeAt(i)) return false
  }
  return true
}

export function isBinaryAudioDurationFormat(file) {
  return isAmrAudioFile(file)
}

export function isAmrAudioFile(file) {
  if (!file) return false
  const ext = fileExtension(file.name)
  if (ext === 'amr') return true
  const mime = String(file.type || '').toLowerCase()
  return mime === 'audio/amr' || mime === 'audio/amr-wb'
}

function parseAmrDuration(bytes) {
  let offset = 0
  let frameSizes = AMR_NB_FRAME_SIZES

  if (bytesStartWith(bytes, AMR_WB_MAGIC)) {
    offset = AMR_WB_MAGIC.length
    frameSizes = AMR_WB_FRAME_SIZES
  } else if (bytesStartWith(bytes, AMR_NB_MAGIC)) {
    offset = AMR_NB_MAGIC.length
  } else {
    throw new Error('AMR signature not found')
  }

  let frames = 0
  while (offset < bytes.length) {
    // TOC: P | FT(4) | Q | P | P  → frame type in bits 3..6
    const frameType = (bytes[offset] >> 3) & 0x0f
    const frameSize = frameSizes[frameType]
    if (!frameSize || offset + frameSize > bytes.length) break
    offset += frameSize
    frames += 1
  }

  if (frames <= 0) {
    throw new Error('AMR contains no frames')
  }

  return frames * 0.02
}

/**
 * 从文件头解析 AMR 时长（浏览器 audio 元素通常不支持）。
 * @param {File|Blob} file
 * @returns {Promise<number>}
 */
export async function readBinaryAudioDuration(file) {
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)
  if (
    !isAmrAudioFile(file) &&
    !bytesStartWith(bytes, AMR_NB_MAGIC) &&
    !bytesStartWith(bytes, AMR_WB_MAGIC)
  ) {
    throw new Error('Unsupported binary audio format')
  }
  return parseAmrDuration(bytes)
}
